import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { memo } from "react";

export const inboundForm = groupInput({
  autoCloseArchivedGmailMessages: input<boolean>(),
});

export type InboundForm = InputSchema.Input<typeof inboundForm>;

export type InboundValue = InputSchema.Value<typeof inboundForm>;

export const inboundDefault: InboundValue = {
  autoCloseArchivedGmailMessages: true,
};

export const InboundCard = memo(function InboundCard({
  input,
}: {
  input: InboundForm;
}) {
  const { autoCloseArchivedGmailMessages } = input.inputs;

  return (
    <Card borderRadius="md" title="Inbound Email">
      <Flex dir="column" gap="lg">
        <RedoToggle
          description="Automatically close tickets when incoming Gmail messages are already archived or muted"
          label="Auto-close archived Gmail messages"
          setValue={autoCloseArchivedGmailMessages.setValue}
          size="sm"
          value={autoCloseArchivedGmailMessages.value}
        />
      </Flex>
    </Card>
  );
});
